export const resolvePropAndContextValue = (prop: boolean | undefined, contextValue: boolean) => {
    if (contextValue) return contextValue;
    else return prop;
};